@if (item) {
  <div class="category-item">
    <div
      class="category-link-container"
      >
      @switch (item.titleTag) {
        @case ('H1') {
          <h1
            >
            <a
              class="category-link"
              [routerLink]="item.urlButton"
              [style.font-size]="item.titleSize"
              [style.font-weight]="item.titleBold === 'true' ? 'bold' : '400'"
              >
              {{ item.title }}
            </a>
          </h1>
        }
        @case ('H2') {
          <h2
            >
            <a
              class="category-link"
              [routerLink]="item.urlButton"
              [style.font-size]="item.titleSize"
              [style.font-weight]="item.titleBold === 'true' ? 'bold' : '400'"
              >
              {{ item.title }}
            </a>
          </h2>
        }
        @default {
          <a
            class="category-link"
            [routerLink]="item.urlButton"
            [style.font-size]="item.titleSize"
            [style.font-weight]="item.titleBold === 'true' ? 'bold' : '400'"
            >
            {{ item.title }}
          </a>
        }
      }
    </div>
  </div>
}
